'use client';

import { IS_SSR } from '@libs/common-next';

import { useProduct } from '@/entities/product';

export const useSizeChart = () => {
    const { base } = useProduct();

    const descriptionTabs = !IS_SSR ? document.querySelectorAll('.product-description [role="tab"]') : [];

    const hasSizeChartImgUrl = Object.values(base?.variants ?? {}).some(variant => variant?.sizeChartImgUrl);
    const hasSizeTab = Array.from(descriptionTabs).some(tab => tab?.textContent === 'Size');
    const isSizeChart = hasSizeTab && hasSizeChartImgUrl;

    const handleSizeChartClick = () => {
        if (isSizeChart) {
            const sizeTab = Array.from(descriptionTabs).find(tab => tab.textContent === 'Size');

            sizeTab?.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                })
            );
        }
    };

    return {
        isSizeChart,
        handleSizeChartClick,
    };
};
